import { useQuery } from '@tanstack/react-query'
import { getPendingEvereePayments, PendingEvereePayment } from 'api/w2/payments'
import { w2Keys } from './keys'

export const usePendingEvereePayments = () =>
  useQuery<PendingEvereePayment[]>({
    queryKey: w2Keys.pendingPayments,
    queryFn: getPendingEvereePayments,
  })
